<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>

<div *ngIf="!telaFormulario" class="content d-flex justify-content-center align-items-center"> 
    <form class="login-form" #telainicial="ngForm" [formGroup]="formTelaInicial">
        <div class="card  bg-dark mb-0 text-ligth">
            <div class="card-body">
                <div class="text-center mb-3">
                    <h5 class="mb-0">Manutenção Bancos de Dados Físicos</h5>
                </div>
                <div class="s-12 col-sm-12 col-md-12 col-lg-12 form-group">
                    <label class="justify-content-start">Serviço</label>
                    <select class="form-control" type="text" formControlName="codServico_form"
                        [ngStyle]="((temErro || formTelaInicial.controls['codServico_form'].dirty) && formTelaInicial.controls['codServico_form'].status == 'INVALID') ? {'border-color':'red'} : null">
                        <option value=""> Selecione...</option>
                        <option *ngFor="let servico of listaServicos" value="{{servico.Codigo}}"> {{servico.Descricao}}
                        </option>
                    </select>
                    <span class="form-text text-danger"
                        *ngIf="formTelaInicial.get('codServico_form').invalid && validaTelaInicial">
                        Campo Obrigatório
                    </span>
                    <span class="form-text text-danger"
                        *ngIf="formTelaInicial.value.codServico_form.length > 0 && formTelaInicial.get('codServico_form').hasError('codServicoError')">
                        Código inválido
                    </span>
                </div>

                <div class=" text-center">
                    <button type="button" (click)="buscarBancosPorCodigo()" class="btn btn-primary">Buscar</button>
                </div>
            </div>
        </div>
    </form>
</div>



<div class="card" *ngIf="telaFormulario">
    <div class="card-header">
        <h3 class="card-title" id="target"> Manutenção de Bancos de Dados Físicos</h3>
    </div>

    <form [formGroup]="formBancosFisicos" (ngSubmit)="submitBancoFisico()" #bancos='ngForm'>
        <div class="card-body">
            <div class="row">

                <div class="col-md-2 form-group">
                    <label class="font-weight-semibold">Código</label>
                    <!-- Verificar, pois possivelmente esse campo sera Disabled, só ira mostrar valor no alterar-->
                    <input class="form-control" type="text" formControlName="codigo" maxlength="20"
                        placeholder="Código"
                        [ngStyle]="((temErro || formBancosFisicos.controls['codigo'].dirty) && formBancosFisicos.controls['codigo'].status == 'INVALID') ? {'border-color':'red'} : null" />
                    <span class="form-text text-danger"
                        *ngIf="temErro && formBancosFisicos.controls['codigo'].hasError('required')">
                        Campo obrigatório
                    </span>
                    <span class="form-text" *ngIf="loadingColaborador">Carregando <i class="fa fa-spinner fa-spin"
                            aria-hidden="false"></i></span>
                </div>

                <div class="col-md-5 form-group">
                    <label class="font-weight-semibold">Descrição</label>
                    <input class="form-control" type="text" formControlName="descricao" placeholder="Descrição" maxlength="80"
                        [ngStyle]="((temErro || formBancosFisicos.controls['descricao'].dirty) && formBancosFisicos.controls['descricao'].status == 'INVALID') ? {'border-color':'red'} : null" />
                    <span class="form-text text-danger"
                        *ngIf="temErro && formBancosFisicos.controls['descricao'].hasError('required')">
                        Campo obrigatório
                    </span>
                </div>

                <div class="col-md-2 form-group">
                    <label class="font-weight-semibold">Servidor</label>
                    <input class="form-control" type="text" formControlName="servidor" placeholder="Servidor" maxlength="100"
                        [ngStyle]="((temErro || formBancosFisicos.controls['servidor'].dirty) && formBancosFisicos.controls['servidor'].status == 'INVALID') ? {'border-color':'red'} : null" />
                    <span class="form-text text-danger"
                        *ngIf="temErro && formBancosFisicos.controls['servidor'].hasError('required')">
                        Campo obrigatório
                    </span>
                </div>

                <div class="col-md-2 form-group">
                    <label class="font-weight-semibold">Nome Banco</label>
                    <input class="form-control" type="text" formControlName="nomeBanco" placeholder="Nome Banco" maxlength="40"
                        [ngStyle]="((temErro || formBancosFisicos.controls['nomeBanco'].dirty) && formBancosFisicos.controls['nomeBanco'].status == 'INVALID') ? {'border-color':'red'} : null" />
                    <span class="form-text text-danger"
                        *ngIf="temErro && formBancosFisicos.controls['nomeBanco'].hasError('required')">
                        Campo obrigatório
                    </span>
                </div>

                <div class="col-md-2 form-group">
                    <label class="font-weight-semibold">Usuário</label>
                    <input class="form-control" type="text" formControlName="login" placeholder="Usuário" maxlength="20"
                        [ngStyle]="((temErro || formBancosFisicos.controls['login'].dirty) && formBancosFisicos.controls['login'].status == 'INVALID') ? {'border-color':'red'} : null" />
                    <span class="form-text text-danger"
                        *ngIf="temErro && formBancosFisicos.controls['login'].hasError('required')">
                        Campo obrigatório
                    </span>
                </div>

                <div class="col-4">
                    <label for="Senha Temp">Senha</label><input name="senha" formControlName="senha" type="password"
                        id="password" class="form-control" placeholder="Senha" aria-label="senha" maxlength="48"
                        aria-describedby="basic-addon1"
                        [ngStyle]="((temErro || formBancosFisicos.controls['senha'].dirty) && formBancosFisicos.controls['senha'].status == 'INVALID') ? {'border-color':'red'} : null" />
                    <i class="fa fa-eye" *ngIf='!revelarOlho' (click)="revelarSenha()" (mouseup)="revelarSenha()"
                        style="position: absolute;top: 40px;right: 20px;cursor: pointer;"></i>
                    <i class="fa fa-eye-slash" *ngIf='revelarOlho' (click)="revelarSenha()" (mouseup)="revelarSenha()"
                        style="position: absolute;top: 40px;right: 20px;cursor: pointer;"></i>
                    <small class="form-text text-danger"
                        *ngIf="temErro && formBancosFisicos.controls['senha'].hasError('required')">Digite
                        uma Senha</small>
                </div>
            </div>
        </div>

        <div class="card-footer text-right ">
            <!--Se todos os campos forem preenchidos e as configurações tambem, disabled = false-->
            <button type="button" (click)="limparCampos()" class="btn btn-danger mr-2">Limpar</button>
            <button [disabled]="formBancosFisicos.invalid" class="btn btn-primary" type="submit">Salvar</button>
        </div>

    </form>
</div>


<div class="card" *ngIf="telaFormulario">
    <div class="card-header">
        <h3 class="card-title"> Listagem dos Bancos de Dados Físicos</h3>
    </div>


    <div class="card-body">
        <div class="d-flex justify-content-center align-items-center">
        </div>
        <div class="form-group row">
            <div class="input-group col-lg-12" *ngIf="listaBancosFisicos != null && listaBancosFisicos.length > 0">
                <input type="text" class="form-control" name="searchText" value="" placeholder="Pesquisar"
                    [(ngModel)]="searchText">
                <span class="input-group-append">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                </span>
            </div>
        </div>

        <div *ngIf="listaBancosFisicos != null && listaBancosFisicos.length > 0" class="table-responsive"
            style="max-height:45vh">
            <table class="table table-striped table-hover">
                <thead class="text-center">
                    <tr class="text-center" style="white-space:nowrap">
                        <th class="sticky-top bg-white"></th>
                        <th class="sticky-top bg-white">Código Serviço</th>
                        <th class="sticky-top bg-white">Código Banco</th>
                        <th class="sticky-top bg-white">Descrição</th>
                        <th class="sticky-top bg-white">Servidor</th>
                        <!-- <th class="sticky-top bg-white">Usuários Da banco</th> -->

                    </tr>
                </thead>
                <tbody id="lista-bancos">
                    <tr *ngFor="let banco of listaBancosFisicos | pesquisaPipe: searchText; let i = index"
                        class="text-center" style="white-space:nowrap">
                        <td>
                            <div>
                                <button [disabled]="idExcluindo === i" class="btn btn-danger mr-2"
                                    (click)="deletar(banco, i)">
                                    <i *ngIf="idExcluindo !== i" class="fa fa-trash"></i>
                                    <i *ngIf="idExcluindo === i" class="fa fa-spinner fa-spin" aria-hidden="false"></i>
                                </button>
                                <button class="btn bg-teal-400" (click)="carregarBanco(banco)">
                                    <i class="fa fa-pencil"></i>
                                </button>
                            </div>
                        </td>
                        <td>{{banco.CodigoServico}}</td>
                        <td>{{banco.CodigoBanco}}</td>
                        <td>{{banco.Descricao}}</td>
                        <td>{{banco.Servidor}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="listaBancosFisicos == null || listaBancosFisicos.length === 0"
            class="d-flex justify-content-center align-items-center" style="height:20vh">
            <h5 class="font-weight-semibold">Não há Bancos Físicos para serem exibidos</h5>
        </div>
    </div>

    <!-- Modal Usuario banco-->

    <div class="modal fade" id="configuracaobanco" tabindex="-1" role="dialog"
        aria-labelledby="configuracaobancoTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header navbar-light bg-light">
                    <div class="container">
                        <div class="row">
                            <div class="col-6">
                                <h5 class="justify-content-start mt-2"> Tipo de banco</h5>
                            </div>
                            <button _ngcontent-nbj-c13="" aria-label="Close" class="mb-4 close" data-dismiss="modal"
                                type="button"><span _ngcontent-nbj-c13="" aria-hidden="true">x</span></button>
                        </div>
                        <br>
                    </div>

                </div>
                <div class="modal-body  navbar-light bg-light">
                    <div class="container">
                        <div class="text-center">

                            <div class="col-12 table-responsive text-center">
                                <div class="row form-group text-center">
                                    <table class="table table-striped table-hover mb-0 text-center">
                                        <thead class="bg-teal-400">
                                            <tr class="text-center" style="white-space:nowrap">
                                                <th style="text-align:left;"></th>
                                                <th>Código</th>
                                                <th>Nome</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!--Aguardando Rota do back ( Relação de Usuários Da banco )-->
                                            <tr *ngFor="let banco of listaBancosFisicos | pesquisaPipe: searchText; let i = index"
                                                class="text-center" style="white-space:nowrap">
                                                <td>
                                                    <div class="form-check">
                                                        <input class="form-check-input" value="{{banco.Codigo}}"
                                                            type="radio" name="flexRadioDefault" id="flexRadioDefault1">
                                                        <label class="form-check-label" for="flexRadioDefault1">
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>{{banco.Codigo}}</td>
                                                <td>{{banco.Descricao}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>